import React, { useCallback, useMemo, useRef, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, Row, Col, FormGroup, Label, Input, Button, CustomInput } from "reactstrap"
import Cargando from 'components/Varios/Cargando'
import ButtonAceptar from 'components/Varios/Modals/ButtonAceptar'
import IconCloseModal from 'components/Varios/Modals/IconCloseModal'
import { FileInfo, FileInfoUrl } from 'components/Types/GeneralTypes'
import InputFileUpload from './InputFileUpload'

type PropsModalFirmarPDF = {
    show: boolean,
    urlArchivo: string,
    size: "xl" | "sm" | "md" | "lg",
    onClose: () => void,
    cargandoDatos: boolean,
    onClickFirma?: (objeto: ObjetoFirmar) => Promise<void>,
    onClickFirmaFisica?: (objeto: ObjetoFirmar) => Promise<void>,
    onClickFirmaAcuerdo: () => Promise<void>,
    tituloModal: string,
    extraData?: any,
    admiteFirmaElectronica: boolean,
    admiteFirmaFisica: boolean
}

type stateModalFirmar = {
    filesEnviar: FileInfoUrl[],
    contrasenia: string,
    firmandoDocumento: boolean,
    tipoFirma: "E" | "F" | "" //"Electronica(Digital) o Fisica"
}

export type ObjetoFirmar = {
    extraData?: any,
    filesEnviar: FileInfoUrl[],
    contrasenia: string
}

export default function ModalFirmarPDFAcuerdo(props: PropsModalFirmarPDF) {

    const stateInicial: stateModalFirmar = {
        filesEnviar: [],
        contrasenia: "",
        firmandoDocumento: false,
        tipoFirma: "E"
    }
    const [stateModal, setstateModalFirmar] = useState<stateModalFirmar>(stateInicial)

    const ButtonAcept = useRef<HTMLButtonElement>();

    const ContenidoModalBody = useMemo(() => {
        if (props.cargandoDatos) {
            return (
                <Cargando />
            )
        }
        else if (!props.cargandoDatos && props.urlArchivo !== "") {
            return (
                <React.Fragment>
                    <div style={{ overflowX: "auto" }} className=" objectPDF ow text-center mb-3">
                        <object data={props.urlArchivo}
                            type="application/pdf"
                        >
                        </object>
                    </div>
                    <Row className="justify-content-center">

                    </Row>
                    {
                        <Row className="ml-2 mt-2">
                        Estimado servidor: al ingresar una nueva solicitud, la anterior quedará inactiva. ¿ Está de acuerdo en ingresar la nueva solicitud ?
                        </Row>
                    }
                    {
                        stateModal.tipoFirma === "F" &&
                        <React.Fragment>
                            <Row className="ml-2 mt-2">
                                <span id="muted">
                                    Usted no ha firmado el acuerdo de medios electrónicos por lo tanto este documento debe ser entregado en la Unidad de Talento Humano
                                    <i className="fas fa-info-circle pl-2" aria-hidden="true" style={{ color: "red" }}></i>
                                </span>
                            </Row>
                        </React.Fragment>
                    }
                </React.Fragment>
            )
        }
        else {
            return (
                <div>
                    No hay contenido por mostrar
                </div>
            )
        }
    }, [props.urlArchivo, props.cargandoDatos, stateModal])

    const BotonCerrar = useMemo(() => {
        return (
            <IconCloseModal
                handleClickIcon={() => CerrarModal()}
            />
        )
    }
        , [props])

    const BotonFirmar = useMemo(() => {
        const { firmandoDocumento, filesEnviar, contrasenia, tipoFirma } = stateModal
        var objeto_pasando: ObjetoFirmar = {
            extraData: props.extraData,
            filesEnviar,
            contrasenia
        }

        /*var requiereContrasenia: boolean = (tipoFirma === "E" && contrasenia !== undefined && contrasenia !== "") || (tipoFirma === "F")*/
        var requiereContrasenia: boolean = (tipoFirma === "E")

        const botonAceptar = document.getElementById("botonAceptar");
        const i_element = document.getElementById("loadingEnviar");

        if (firmandoDocumento && botonAceptar !== null /*&& filesEnviar.length > 0*/ && requiereContrasenia) {
            const i = document.createElement("i");
            i.setAttribute("id", "loadingEnviar")
            i.setAttribute("class", "fa fa-spin fa-spinner")
            botonAceptar.textContent = "Firmando... "
            botonAceptar.insertBefore(i, null)
            botonAceptar.setAttribute("disabled", "true")

            return (
                <Button color="primary" id="botonAceptar" onClick={() => handleFirmar(objeto_pasando)}  >Aceptar</Button>
            )
        }
        else if (!firmandoDocumento && botonAceptar !== null && i_element !== null /*&& filesEnviar.length > 0*/ && requiereContrasenia) {
            i_element.remove();
            botonAceptar.setAttribute("disabled", "false")

            return (
                <Button color="primary" id="botonAceptar" onClick={() => handleFirmar(objeto_pasando)}  >Aceptar</Button>
            )
        }
        else if (!firmandoDocumento /*&& filesEnviar.length > 0*/ && requiereContrasenia) {

            return (
                <Button color="primary" id="botonAceptar" onClick={() => handleFirmar(objeto_pasando)}  >Aceptar</Button>
            )
        }
    }
        , [stateModal, props.extraData])

    function handleFileUploadChange(archivo: FileInfo) {
        var uploadFile = new File([archivo.file], archivo.id + ".pdf");

        const src = window.URL.createObjectURL(uploadFile);

        const firmaArchivoInfo: FileInfoUrl = {
            nombreFile: archivo.nombreFile,
            file: uploadFile,
            id: archivo.id,
            url: src
        };

        setstateModalFirmar({
            ...stateModal,
            filesEnviar: [firmaArchivoInfo],
        })

    }

    function handleChangeContra(e: string) {
        var _contrasenia_ = new TextEncoder().encode(e).toString();
        setstateModalFirmar({ ...stateModal, contrasenia: _contrasenia_ })
    }

    const handleFirmar = useCallback(
        async (objetoFirmar: any) => {
            setstateModalFirmar({ ...stateModal, firmandoDocumento: true })
            if (stateModal.tipoFirma === "E") {
                await props.onClickFirmaAcuerdo();
                //await props.onClickFirma(objetoFirmar);
            }
            else if (stateModal.tipoFirma === "F" && typeof (props.onClickFirmaFisica) === "function") {
                await props.onClickFirmaFisica(objetoFirmar);
            }
            setstateModalFirmar({ ...stateModal, firmandoDocumento: false })
        }
        , [stateModal])

    function CerrarModal() {
        setstateModalFirmar(stateInicial);
        props.onClose()
    }

    const BotonCancelar = useMemo(() => {
        return (
            <Button color="secondary" id="botonCancelar" disabled={stateModal.firmandoDocumento} onClick={() => CerrarModal()}>Cancelar</Button>
        )
    }, [stateModal, props])
    return (
        <Modal
            isOpen={props.show}
            scrollable={true}
            size={props.size}
            fullscreen={props.size}
            centered={true}
            onClosed={() => CerrarModal()}
        // contentClassName="custom-modal-style"
        >
            <ModalHeader close={BotonCerrar}>
                <div className='tituloModalDocumentos'>{props.tituloModal}</div>
            </ModalHeader>
            <ModalBody>
                {ContenidoModalBody}
            </ModalBody>
            <ModalFooter>

                {BotonFirmar}
                {BotonCancelar}
            </ModalFooter>
        </Modal>

    )
}
